import {resolveBackground} from '#core/utils/color-utils.js';
import {icon} from '#core/utils/style-utils.js';

import {generateBorder} from '#core/application/modules/tiles/border/index.js';

export function slidingBetslipButtonFactory(PALETTE) {
    return {
        BetslipButtonState: {
            minimizedButton: {
                view: {
                    button: {
                        style: {
                            base: {
                                borderRadius: '40px',
                                fontSize: '20px',
                                width: 40,
                                height: 40,
                            },
                        },
                    },
                },
            },
        },
        BetslipButtonView: {
            button: {
                style: {
                    base: {
                        ...resolveBackground(PALETTE.BETSLIP_PILL_BASE_BG),
                        flexGrow: '0',
                        flexShrink: '0',
                        flexBasis: 'auto',
                        minHeight: 'initial',
                        borderWidth: '0px',
                        borderRadius: '48px',
                        boxShadow: PALETTE.BETSLIP_PILL_SHADOW,
                        width: 48,
                        height: 48,
                        ...PALETTE.BETSLIP_PILL_BASE_TEXT,
                    },
                },
            },
            style: {
                highlighted: {
                    ...resolveBackground(PALETTE.BETSLIP_PILL_HIGHLIGHTED_BG),
                    ...PALETTE.BETSLIP_PILL_HIGHLIGHTED_TEXT,
                },
            },
            imageButton: {
                button: {
                    style: {
                        base: {
                            ...resolveBackground(PALETTE.BETSLIP_PILL_SUCCESS_BG),
                            flexGrow: '0',
                            flexShrink: '0',
                            flexBasis: 'auto',
                            minHeight: 'initial',
                            borderRadius: 48,
                            boxShadow: PALETTE.BETSLIP_PILL_SHADOW,
                            height: 48,
                            width: 48,
                        },
                    },
                },
                buttonIcon: icon(PALETTE.BETSLIP_PILL_SUCCESS_ICON_COLOR),
            },
            overaskImageButton: {
                button: {
                    style: {
                        base: {
                            ...resolveBackground(PALETTE.BETSLIP_PILL_OVERASK_BG),
                            flexGrow: '0',
                            flexShrink: '0',
                            flexBasis: 'auto',
                            borderRadius: 48,
                            boxShadow: PALETTE.BETSLIP_PILL_SHADOW,
                            height: 48,
                            width: 48,
                        },
                    },
                },
                buttonIcon: icon(PALETTE.BETSLIP_PILL_OVERASK_ICON_COLOR),
            },
            freebetsIconContainer: {
                style: {
                    ...resolveBackground(PALETTE.BETSLIP_PILL_FREEBETS_CONTAINER_BG),
                    borderRadius: 16,
                    // override Mojito default positioning according to RBM
                    right: 0,
                    top: 0,
                },
            },
            freebetsIcon: {
                style: {
                    minWidth: '14px',
                    minHeight: '14px',
                    fill: PALETTE.BETSLIP_PILL_FREEBETS_ICON_COLOR,
                },
            },
        },
        FloatingBetslipPill: {
            oddsContainer: {
                style: {
                    boxShadow: PALETTE.BETSLIP_PILL_SHADOW,
                    ...resolveBackground(PALETTE.BETSLIP_PILL_BET_INFO_BG),
                    ...generateBorder(PALETTE.BETSLIP_PILL_OUTLINE),
                },
            },
            betTypeLabel: {
                style: {
                    ...PALETTE.BETSLIP_PILL_BET_INFO_TYPE_TEXT,
                },
            },
            oddsLabel: {
                style: {
                    ...PALETTE.BETSLIP_PILL_BET_INFO_PRICE_TEXT,
                },
            },
            baseBetslipButtonState: {
                button: {
                    view: {
                        button: {
                            style: {
                                base: {
                                    borderRadius: 40,
                                    width: 40,
                                    height: 40,
                                },
                            },
                        },
                        imageButton: {
                            button: {
                                style: {
                                    base: {
                                        borderRadius: 40,
                                        width: 40,
                                        height: 40,
                                    },
                                },
                            },
                        },
                        overaskImageButton: {
                            button: {
                                style: {
                                    base: {
                                        borderRadius: 40,
                                        width: 40,
                                        height: 40,
                                    },
                                },
                            },
                        },
                    },
                },
            },
            openedBetslipButtonState: {
                container: {
                    style: {
                        transform: 'translate(0%, -44px)',
                    },
                },
            },
            closedBetslipButtonState: {
                container: {
                    style: {
                        transform: 'translate(0px, calc(-140px - env(safe-area-inset-bottom, 0px)))',
                        height: 40,
                        width: 40,
                    },
                },
            },
        },
    };
}
